const PNG = "image/png";

const toPng = async (blob) => {
  if (blob.type === PNG) return blob;
  const bitmap = await createImageBitmap(blob);
  const canvas = document.createElement("canvas");
  canvas.width = bitmap.width;
  canvas.height = bitmap.height;
  canvas.getContext("2d").drawImage(bitmap, 0, 0);
  bitmap.close?.();
  return new Promise((resolve, reject) =>
    canvas.toBlob(
      (png) => (png ? resolve(png) : reject(new Error("Could not prepare the image"))),
      PNG
    )
  );
};

/**
 * Copies an image to the system clipboard as a png, which is the one image type every browser
 * accepts. `loadBlob` is called inside the click and its promise is handed to the clipboard
 * item rather than awaited first: Safari drops the write if the user gesture has expired by the
 * time a slow download finishes.
 */
export const copyImageToClipboard = async (loadBlob) => {
  if (!navigator.clipboard?.write || typeof ClipboardItem === "undefined") {
    throw new Error("Copying images is not supported in this browser");
  }
  const png = Promise.resolve().then(loadBlob).then(toPng);
  await navigator.clipboard.write([new ClipboardItem({ [PNG]: png })]);
};
